import React, { ChangeEvent, ReactElement } from 'react';
import classNames from 'classnames';
import { Typography, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SanitizedHTML } from '@alycecom/ui';
import { DeepMap, FieldError } from 'react-hook-form';

import TruncatedText from '../../../../components/TruncatedText/TruncatedText';

export interface ITextProductOptions {
  value: string;
  description?: string;
  errors: DeepMap<{ option: string }, FieldError>;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

const useStyles = makeStyles(({ breakpoints }) => ({
  text: {
    wordBreak: 'break-word',
  },
  nonTruncated: {
    [breakpoints.down('sm')]: {
      overflowY: 'scroll',
      maxHeight: 300,
    },
  },
}));

const TextProductOptions = ({ value, description, errors, onChange }: ITextProductOptions): ReactElement => {
  const classes = useStyles();
  return (
    <>
      <Typography className="H4-Dark-Bold">Options to select from:</Typography>
      <TruncatedText overrideClasses={classes}>
        <SanitizedHTML className={classNames('Body-Regular-Left-Static', classes.text)} html={description || ''} />
      </TruncatedText>
      <TextField
        id="field-option-id"
        data-testid="customProductOptionsField"
        name="option"
        fullWidth
        variant="outlined"
        multiline
        rows={3}
        value={value}
        onChange={onChange}
        error={!!errors.option}
        helperText={errors.option && errors.option.message}
        placeholder="Type your selection here"
      />
    </>
  );
};

export default TextProductOptions;
